/*
* 发布环境: https://japi-o.zzrcer.com
* pre预发布环境: http://ebjpre.zzrcer.com:9088
* sas环境: http://ebjsas.zzrcer.com:8988 
* dev环境: http://ebjdev.zzrcer.com 
* qa环境: http://ebjqa.zzrcer.com:8888 
* 青云环境: https://msapi.zzrcer.com 
*/

const url = global.origin
let host
let type = 'default'

// 各环境对应的域名
let urlParams = {
  dev: 'https://ebjdev.zzrcer.com',
  pre: 'https://zqmsapi-o.zzrcer.com',
  qa: 'https://ebjqa.zzrcer.com',
}

// 循环获取当前环境并保存
// type：环境名
// host：域名
for(let key in urlParams) {
  if (url && url.indexOf(key) >= 0) {
    type = key
    host = url
    break
  } else if(url && url.indexOf('://www.zzrc.tech') >= 0 && key == 'pre') {
    host = urlParams[key]
    type = key
    break
  } else {
    type = 'default'
    host = url || `https://ebjdev.zzrcer.com`
  }
}
host = url && url.indexOf('https') < 0 ? host.replace('https', 'http') : host
console.log(url, host)
module.exports = {
  host: host,
  type: type,
}
